import colors from './colors'

//Background colors
const bg = {
  dark1: colors.black._50,
  dark2: colors.black._150,
  dark3: colors.black._250,
  light1: colors.whiteColor,
  light2: colors.black._950,
  light3: colors.black._900,
  primary: colors.primary._400,
  primaryLight: colors.primary._600,
  secondary: colors.secondary._400,
  secondaryLight: colors.secondary._600,
  error: colors.error._600,
  warning: colors.warning._600,
  success: colors.success_600,
  active: colors.active._500,
  activeHover: colors.active._400,
  activeDark: colors.active._300,
  dropdownHover: colors.black._950,
  dropdownActive: colors.black._950
}

//Borders
const border = {
  dropdownBorder: colors.black._800
}

//Font colors
const textColor = {
  base: colors.black._200,
  alt: colors.black._400,
  disabled: colors.black._700,
  baseLight: colors.black._800,
  altLight: colors.black._600,
  disabledLight: colors.black._400,
  white: colors.whiteColor,
  black: colors.blackColor,
  linkColor: colors.linkColor,
  linkColorHover: '#6E12DE',
  linkColorActive: colors.black._200,
  linkColorLight: '#86B2F9',
  linkColorHoverLight: '#AFA4F4',
  linkColorActiveLight: colors.black._800,
  primary: colors.primary._400,
  primaryLight: colors.primary._600,
  secondary: colors.secondary._400,
  secondaryLight: colors.secondary._600,
  error: colors.error._400,
  errorLight: colors.error._600,
  warning: colors.warning._350,
  warningLight: colors.warning._650,
  success: colors.success._400,
  successLight: colors.success._700
}

const colorsUI = {
  bg,
  border,
  textColor
}

export default colorsUI



// WEBPACK FOOTER //
// ./src/global/colorsUI.js